<template>
  <div id="SectionBCorpFAQs">
    <UIContainer class="SectionBCorpFAQs__container">
      <template #left>
        <SectionTitle>
          <template #title>FAQs</template>
          <template #description>
            Ready to navigate the new standards with confidence?
            <UIButtonText class="SectionBCorpFAQs__support-link" to="/contact">
              Book a B Corp Strategy Call
            </UIButtonText>
          </template>
        </SectionTitle>
      </template>

      <template #right>
        <UIFaqs :faqs="faqs" />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButtonText from '@/views/components/ui/buttons/UIButtonText.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIFaqs from '@/views/components/features/faqs/UIFaqs.vue'

const faqs = [
  {
    question: 'What is the B Impact Assessment (BIA)?',
    answer:
      "The B Impact Assessment is a rigorous framework developed by B Lab to evaluate a company's social and environmental performance. It reviews policies and practices across the business to highlight strengths and pinpoint clear opportunities for improvement.",
  },
  {
    question: 'Which five impact areas does the BIA cover?',
    answer:
      'The assessment examines Governance, Workers, Community, Environment, and Customers. It considers accountability and ethics, people practices, community impact, environmental stewardship, and how products or services create positive outcomes.',
  },
  {
    question: 'How does the BIA address carbon emissions?',
    answer:
      'Carbon management is assessed within the Environment section. Questions focus on measuring emissions, planning and reducing GHGs, and using renewable energy. Companies that actively track and lower emissions score higher, reflecting robust environmental responsibility.',
  },
  {
    question: 'What is considered a strong B Corp score?',
    answer:
      'Certification requires a minimum verified score of 80 points. Many companies land between 80 and 100, while scores above 120 typically indicate outstanding leadership in sustainability and social impact.',
  },
  {
    question: 'What topics do BIA questions typically cover?',
    answer:
      "The BIA includes questions on governance, employee well-being, diversity and inclusion, environmental practices, and customer impact. The questionnaire adapts to a company's size, geography, and industry to ensure relevance.",
  },
]
</script>

<style lang="scss" scoped>
#SectionBCorpFAQs {
  background-color: $color-white;
  .SectionBCorpFAQs__container {
    :deep(.UIContainer__grid) {
      display: flex;
      flex-direction: column;
      align-items: stretch;

      @include md {
        flex-direction: row;
        align-items: normal;
      }

      .UIContainer__left {
        width: 100%;
        @include md {
          width: 40%;
          padding-right: 3rem;
        }
      }
      .UIContainer__right {
        width: 100%;
        margin-top: 1rem;
        @include md {
          width: 60%;
          margin-top: 0;
        }
      }
    }
  }

  .SectionBCorpFAQs__support-link {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
